var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfternoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 15.5L6.67952 13.7852L4.74584 14.7573L4.3002 12.6394L2.13622 12.6762L2.65363 10.5746L0.687988 9.6689L2.066 8L0.687988 6.3311L2.65363 5.42536L2.13622 3.32384L4.3002 3.36063L4.74584 1.24273L6.67952 2.2148L7.99996 0.5L10.4291 8L7.99996 15.5Z",
    fill: "#FFB655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9339 8L15.3119 6.3311L13.3462 5.42536L13.8637 3.32384L11.6997 3.36063L11.254 1.24273L9.32036 2.2148L7.99992 0.5V15.5L9.32036 13.7852L11.254 14.7573L11.6997 12.6394L13.8637 12.6762L13.3462 10.5746L15.3119 9.6689L13.9339 8Z",
    fill: "#FFB655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78707 8.00003L7.99996 11.9664C5.80938 11.9664 4.03357 10.1906 4.03357 8.00003C4.03357 5.80948 5.80938 4.03365 7.99996 4.03365L9.78707 8.00003Z",
    fill: "#FFE89C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 4.03365C10.1905 4.03365 11.9663 5.80948 11.9663 8.00003C11.9663 10.1906 10.1905 11.9664 7.99992 11.9664V4.03365Z",
    fill: "#FFE89C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfternoon);
export default __webpack_public_path__ + "static/media/afternoon.a71ac7de5cc9862b9cc5823e8d405bd5.svg";
export { ForwardRef as ReactComponent };